<template>
<div class="item" :id="'tab-' + media">
    <div class="item-container">
        <div class="item-panel">
            <div class="col-xs-12 title" v-if="graph1.hasData == 'yes'">
                {{getPeriod}} <u>{{filter}}</u> Evolution
            </div>

            <div class="col-xs-12" v-if="graph1.hasData == 'yes'">
                <div class="graph-container fixed-graph">
                    <chart v-if="graph1.data.datasets.length > 3" :raw-data="graph1.data" :media="media" :chart-id="media + '-canvas'" :filter="filter" :period="period" :fill="false"></chart>
                    <bar-chart v-else :raw-data="graph1.data" :media="media" :chart-id="media + '-canvas'" :filter="filter" :period="period" :fill="false"></bar-chart>
                </div>
            </div>

            <div v-if="graph1.hasData == 'no' && !country.code" class="panel-text"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>Not enough data<br>to generate the chart.</p></div>
            <div v-if="graph1.hasData == 'no' && country.code" class="panel-text"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>No data available for <b>{{country.name}}</b><br>to generate the chart.</p></div>

            <loader v-if="graph1.hasData == 'pending'" color="ripple" size="150px" style="height: 280px;"></loader>
        </div>

        <div class="item-panel" v-if="isExtended">
            <div class="col-xs-12 title" v-show="graph2.hasData == 'yes'">
                <span>PLAYS BY COUNTRY</span>
            </div>            

            <div class="col-xs-12" v-show="graph2.hasData == 'yes'">
                <div class="graph-container">
                    <div class="graph-bar">
                        <chart-radio :media="media" :raw-data="graph2.data" :chart-id="media + '-canvas-2'"></chart-radio>
                    </div>
                </div>

                <div class="graph-axis">
                    <chart-radio :media="media" :raw-data="graph2.data" :chart-id="media + '-canvas-2'"></chart-radio> 
                </div>
            </div>

            <div class="col-xs-12 panel-text" v-if="graph2.hasData == 'no' && !country.code"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>Not enough data<br>to generate the chart.</p></div>
            <div class="col-xs-12 panel-text" v-if="graph2.hasData == 'no' && country.code"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>No data available for <b>{{country.name}}</b><br>to generate the chart.</p></div>
 
            <div class="col-xs-12" v-show="graph2.hasData == 'pending'">
                <loader color="ripple" size="150px" style="height: 280px;"></loader>
            </div>
        </div>

        <div class="item-panel" v-else>
            <div class="col-xs-12 title" v-show="graph2.hasData == 'yes'">
                <span>PLAYS BY COUNTRY</span>
            </div>
            <div class="col-xs-12 panel-text"><p><i class="iconify icon:iwwa:chart-style1" data-height="64"></i><br>No data available for <b>{{getName}}</b><br>to generate the chart.</p></div>
        </div>

        <div class="item-panel" v-if="allowedMedia">
            <div v-if="!isExtended && country.code" class="panel-text">
                <p><i class="iconify icon:mdi:playlist-music" data-height="64"></i><br>No data available for <b>{{country.name}}</b><br>to generate the chart.</p>
            </div>

            <div v-else>
                <div class="col-xs-12" v-if="period == 'year'">
                    <span class="title">Uploaded songs total views</span>
                </div>
                <div class="col-xs-12" v-else>
                    <span class="title" v-html="getListTitle"></span>
                    <div class="button btn btn-swap" @click="sortSongList()">
                        {{getListButton}} <span class="iconify icon:mdi:swap-horizontal-bold"></span>
                    </div>
                </div>

                <list-songs v-if="requestData" filter="Search" :request-data="requestData" :layout="'line'" playlist-name="Uploaded Songs" :tabid="'tab-songs-' + this.media" :showData="'trending'" :origin="origin"></list-songs>
            </div>
        </div>        
    </div>

    <div class="paginator text-center" v-show="graphPage != -1">
        <span v-show="graphPage != 0" @click="graphPage = 0"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="graphPage == 0" @click="graphPage = 0"><i class="iconify icon:ic:round-brightness-1 active"></i></span>

        <span v-show="maxPages > 1 && graphPage != 1" @click="graphPage = 1"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="maxPages > 1 && graphPage == 1" @click="graphPage = 1"><i class="iconify icon:ic:round-brightness-1 active"></i></span>

        <span v-show="maxPages > 2 && graphPage != 2" @click="graphPage = 2"><i class="iconify icon:ic:round-brightness-1"></i></span>
        <span v-show="maxPages > 2 && graphPage == 2" @click="graphPage = 2"><i class="iconify icon:ic:round-brightness-1 active"></i></span>
    </div>   
</div>
</template>

<script>
export default {
    props: ['playlist', 'media', 'period', 'filter', 'country', 'overallStats', 'selected'],

    components: {
        'list-songs': require('@/components/Song/List.vue').default,        
        'chart': require('@/components/Song/Show/Tab/Statistics/Charts/Chart.vue').default,
        'bar-chart': require('@/components/Song/Show/Tab/Statistics/Charts/BarChart.vue').default, 
        'chart-radio': require('@/components/Song/Show/Tab/Statistics/Charts/Chart-Radio.vue').default,    
        'loader': require('@/components/Loader.vue').default,
    },

    data() {
        return {
            origin: "",
            graphPage: -1,
            graph1: {
                data: null,
                rawData: {
                    datasets: null,
                    labels: null                        
                },
                hasData: 'pending',
            },

            graph2: {
                data: {datasets: [], labels: []},
                dataOriginal: {datasets: [], labels: []},
                hasData: 'pending',
            },

            requestData: false,
            from: 0,
            to: 0,
        }
    },

    mounted() {
        this.origin = `playlist.${ this.isOwner ? "own" : ""} Playlist / ${ this.getName } / Top List`;
        this.graphPage = 0;

        $(`#tab-${this.media} .item-container`).on('scroll', () =>{
            var sL = $(`#tab-${this.media} .item-container`).scrollLeft();
            var sW = $(`#tab-${this.media} .item-container`).width();
            this.graphPage = Math.round(sL / sW);
        });
    },

    methods: {
        getData(graph){
            /// get time interval based on period
            this.to = moment().format('YYYY-MM-DD');

            switch (this.period){
                case 'year':   this.from = moment().subtract(1, 'year').format('YYYY-MM-DD'); break;
                case 'months': this.from = moment().subtract(3, 'months').format('YYYY-MM-DD'); break;
                case 'month':  this.from = moment().subtract(1, 'months').format('YYYY-MM-DD'); break;
                case 'week':   this.from = moment().subtract(7, 'days').format('YYYY-MM-DD'); break;
                case 'day':    this.from = moment().subtract(1, 'days').format('YYYY-MM-DD'); break;
            }

            if (graph == 'graph1'){
                this.$http.get(this.chartDataEndpoint).then((success) => {
                    this[graph].rawData = success.data.data || success.data.results || {data: null};

                    var hasLabels = typeof this[graph].rawData.labels !== 'undefined';
                    var hasDatasets = typeof this[graph].rawData.datasets !== 'undefined' && this[graph].rawData.datasets.reduce((a, b) => a + b, 0);

                    if (!hasLabels || !hasDatasets) {
                        this[graph].hasData = 'no';
                        
                        //fill stuff with empty values
                        var date = new Date();
                        this[graph].rawData = {
                            datasets: [],
                            labels: []
                        }

                        for (var i = 0; i < 366; i++) {
                            this[graph].rawData.datasets.push(null);
                            this[graph].rawData.labels.push( moment(date.addDays(i - 366)).format("YYYY-MM-DD") );   
                        }                    
                    }else{
                        this[graph].hasData = this.country.code && ['shazam', 'soundcloud', 'allchannels'].indexOf(this.media) > -1 ? 'no' : 'yes';
                    }

                    this.processData(graph);
                });
            }

            if (graph == 'graph2' && this.isExtended){ 
                this.$http.get(this.countryEndpoint).then((success) => {
                    var response = success.data.data;
                    var data = {datasets: [], labels: [], type: 'country'}

                    $.each(response, (i, result) => {
                        data.labels.push(result.country);
                        data.datasets.push(parseInt(result.views));
                    })

                    if (response && response.length){
                        var h = data.labels.length * 50 + 24;
                        $('#'+ this.media +'-canvas-2').closest('.graph-bar').css('height', h + 'px' );
                        $('#'+ this.media +'-canvas-2').closest('.graph-container').parent().find('.graph-axis').css('display', h > 300 ? 'block' : 'none');

                        this.graph2.data = data;
                        this.graph2.dataOriginal = data;
                        this.graph2.hasData  = 'yes';
                        this.sortCountries();
                        this.processData(graph);
                    }else{
                        this.graph2.hasData  = 'no';
                    }

                }, (error) => { console.log(error); });
            }
        },

        processData(graph = 'graph1') {
            var N = 0;
            var datasets = [];
            var labels = [];
            var lastIndex = null;
            var currentIndex = null;
            var date = null;
            var updateEvolution = graph == ('graph' + (this.graphPage + 1));

            if (graph == 'graph2'){
                this.sortCountries();
                if (updateEvolution) this.$parent.$emit('evolution-update', this.media, this.country.code ? [this.graph2.data.datasets[0]] : this.graph2.data.datasets, this.country.code ? this.graph2.data.datasets[0] : false);
                return;
            }

            switch(this.period) {
                case 'year': N = 365; break;
                case 'months': N = 90; break;
                case 'month': N = 30; break;
                case 'week': N = 7; break;
                case 'day': N = 0; break;
            }

            for (var i = 365 - N; i < 366 ; i++) { 
                date = new Date(this[graph].rawData.labels[i]);
                switch (this.filter) {
                    case 'daily': currentIndex = this[graph].rawData.labels[i]; break; 
                    case 'weekly': currentIndex = date.getWeek(); break;
                    case 'monthly': currentIndex = date.getMonth(); break;
                }

                if (lastIndex != currentIndex){
                    lastIndex = currentIndex;
                    datasets.push(0);
                    labels.push(this[graph].rawData.labels[i]);
                }

                datasets[datasets.length - 1] += this[graph].rawData.datasets[i];
            }
            
            if (updateEvolution) this.$parent.$emit('evolution-update', this.media, datasets, this[graph].rawData.views_sum);

            // remove last week/month, because we always reffere to last full week/month of data
            // if (this.filter != 'daily'){
            //     datasets.pop();
            //     labels.pop();
            // }

            // 1 point data ?
            if (datasets.length == 1){
                datasets = [null, datasets[0], null];
                labels = [moment(labels[0]).subtract(1, 'days').format('YYYY-MM-DD'), labels[0], moment(labels[0]).subtract(-1, 'days').format('YYYY-MM-DD')];
            }            
 
            this[graph].data = {
                'datasets': datasets,
                'labels': labels
            }
        },

        sortSongList(refresh = false){
            var data = this.requestData ? $.extend(true, {}, this.requestData) : {
                    'playlists': [this.playlist.id],
                    'published' : false,
                    'privacy' : true,
            };
            var m = this.media;
            var p = 'monthly';
            
            switch (this.period){
                case 'week': p = 'weekly'; break;
                case 'day' : p = 'daily'; break;
            }

            if (this.period == 'year'){
                data.order_by_provider_views = `${m}.desc`;
                data.order_by_financial = false;
                data.order_by_evolution = false;
            }else{
                if( data.order_by_provider_views ){
                    data.order_by_provider_views = false;
                    data.order_by_financial = `${m}.${p}.desc`;
                    data.order_by_evolution = false;
                }else if( data.order_by_evolution ){
                    data[ refresh ? 'order_by_evolution' : 'order_by_financial' ] = `${m}.${p}.desc`;
                    data[ refresh ? 'order_by_financial' : 'order_by_evolution' ] = false;
                }else{
                    data[ refresh ? 'order_by_financial' : 'order_by_evolution' ] = `${m}.${p}.desc`;
                    data[ refresh ? 'order_by_evolution' : 'order_by_financial' ] = false;
                }                
            }

            if (this.country.code){
                data.country_id = this.country.code;
            }else{
                delete data.coutnry_id;
            }

            if (JSON.stringify(this.requestData) !== JSON.stringify(data)){
                this.requestData = data;
            }
        },

        sortCountries(){
            var data = $.extend(true, {}, this.graph2.dataOriginal);
 
            if (this.country.code){

                var pos = data.labels.indexOf(this.country.name);

                if (pos > -1){
                    data.datasets.unshift(data.datasets.splice(pos, 1)[0]);
                    data.labels.unshift(data.labels.splice(pos, 1)[0]);
                }else{
                    data.datasets.unshift(0);
                    data.labels.unshift(this.country.name);
                }
            }

            this.graph2.data = data;
        }       
    },

    computed: {
        getPeriod(){
            switch (this.period){
                case 'year':   return this.overallStats ? 'All Time' : 'Last Year'; break;
                case 'months': return 'Last 3 Months'; break;
                case 'month':  return 'Last Month'; break;
                case 'week':   return 'Last Week'; break;
                case 'day':   return 'Yesterday'; break;
            }
        },

        getName(){
            switch (this.media){
                case 'total_streams': return 'All Channels';
                case 'spotify_plays': return 'Spotify'; break;
                case 'spotify_playlists': return 'Spotify Playlists'; break;
                case 'warm_music': return 'Radio'; break;
                case 'apple_music': return 'Apple Music'; break;
                case 'shazam': return 'Shazam'; break;
                case 'soundcloud': return 'Soundcloud'; break;
                default: return this.media;
            }  
        },
        
        getListTitle(){
            var p = 'Last Month';
            switch (this.period){
                case 'week': p = 'Last Week'; break;
                case 'day':  p = 'Last 24h'; break;
            }

            return `Uploaded Songs <u>${p}</u>`;
        },

        getListButton(){
            return this.requestData.order_by_financial == false ? 'Evolution' : 'Growth';
        },

        allowedMedia(){
            return ["youtube", "soundcloud", "shazam", "spotify_plays", "warm_music", "apple_music"].indexOf(this.media) > -1;
        },

        isExtended(){
            return  ['soundcloud', 'shazam', 'total_streams'].indexOf(this.media) == -1 ;
        },

        maxPages(){
            return this.allowedMedia ? 3 : 1;
        },        

        chartDataEndpoint() {
            return `${App.restApi}/api/v2/playlists/${this.playlist.id}/stats/chart?days=365${this.media != 'total_streams' ? "&provider="+this.media : ""}${this.country.code ? "&country_id="+this.country.code : ""}`;
        },

        countryEndpoint() {
            return `${App.restApi}/api/v2/playlists/${this.playlist.id}/stats/${this.media}/countries?from=${this.from}&until=${this.to}${this.country.code ? "&country_code="+this.country.code : ""}`;
        },

        isOwner(){
            return this.playlist.user.id == App.user.id;
        }        
    },

    watch: {
        graphPage(){
            var g = 'graph' + (this.graphPage + 1);

            if (this.graphPage < 2){
                if (this[g].hasData == 'pending'){
                    this.getData(g); 
                }else{
                    this.processData(g);
                }
            }else{
                this.sortSongList(true);
            }

            if(this.selected){
                if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                    'page_path' : `/playlist/statistics/${ this.media }/${ this.graphPage == 0 ? "graph" : "toplist"}`,
                    'page_location': `/playlist/statistics/${ this.media }/${ this.graphPage == 0 ? "graph" : "toplist"}`,
                    'page_title' : `${ this.isOwner ? 'Own' : ''} Playlist > Statistics > ${ this.getName} > ${ this.graphPage == 0 ? "General stats" : "Songs list" }`,
                });
            }
        },

        selected(){ 
            if ( this.selected ){
                if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                    'page_path' : `/playlist/statistics/${ this.media }/${ this.graphPage == 0 ? "graph" : "toplist"}`,
                    'page_location': `/playlist/statistics/${ this.media }/${ this.graphPage == 0 ? "graph" : "toplist"}`,
                    'page_title' : `${ this.isOwner ? 'Own' : ''} Playlist > Statistics > ${ this.getName} > ${ this.graphPage == 0 ? "General stats" : "Songs list" }`,
                });
            }
        },

        country(){
            var g = 'graph' + (this.graphPage + 1);

            if (g == 'graph1'){
                this.getData(g); 
            }

            if (g == 'graph2'){
                this.processData(g);
            }

            if (g == 'graph3'){
                this.sortSongList(true);
            }            
        },

        period(){
            if (this.graph1.hasData == 'yes') this.processData('graph1');
            this.graph2.hasData = 'pending';
            this.getData('graph2');

            if (this.graphPage == 2){
                this.sortSongList(true);
            }
        },
    }
}
</script>